import type {ComponentType, FC} from 'react'
import {Redirect} from 'react-router-dom'
import type {RouteComponentProps} from 'react-router-dom'

import {TENANT_NO_STORAGE_RESIDENCY_REGION} from 'definitions/tenantConfig'
import {useTenantConfigQuery} from 'hooks/useTenantConfigQuery'
import {AnalyticsRoutesEnum} from 'interfaces'

/**
 * Wraps an analytics route: no-storage tenants are redirected to analytics overview.
 */
export function withAnalyticsNoStorageRedirect<P extends RouteComponentProps>(
  Wrapped: ComponentType<P>,
): FC<P> {
  const Guarded: FC<P> = props => {
    const tenantConfigQuery = useTenantConfigQuery()
    const isNoStorageTenantResidency =
      tenantConfigQuery.isSuccess &&
      tenantConfigQuery.data?.data?.residencyRegion ===
        TENANT_NO_STORAGE_RESIDENCY_REGION
    if (isNoStorageTenantResidency) {
      return <Redirect to={AnalyticsRoutesEnum.ANALYTICS_OVERVIEW} />
    }
    return <Wrapped {...props} />
  }
  const wrappedName = Wrapped.displayName ?? Wrapped.name ?? 'Component'
  Guarded.displayName = `withAnalyticsNoStorageRedirect(${wrappedName})`
  return Guarded
}
